import React, { useState, useEffect, createContext, useContext } from "react";
import {
  getAlbumbyId,
  getAllAlbums,
} from "../../modules/OrganizationAlbums/hooks/AlbumsHooks";
import {
  getSingleQuickTale,
  getSingleUser,
} from "../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { useAuth } from "../../hooks";
import { formatLength } from "../../constants";
import { getAllGAAlbums } from "../../GeneralAdmin/modules/GAAlbums/hooks/AlbumsHooks";
import { resolveCreatedByData } from "../../utils/createdByUtils";

export const AlbumsContext = createContext();
export const useAlbumsContext = () => useContext(AlbumsContext);

export const AlbumProvider = ({ children }) => {
  const [allAlbums, setAllAlbums] = useState([]);
  const [allGAAlbums, setAllGAAlbums] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentUser, organizationId } = useAuth();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  // useEffect(() => {
  //   // handleGetAllAlbums();
  // }, []);

  const handleGetAllGAAlbums = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllGAAlbums();
      const albumsPromises = querySnapshot.docs.map(async (item) => {
        const quicktale = item.data().quicktales;
        const quicktalesInfo = await handleQuicktalesData(quicktale);

        const quicktaleData = quicktalesInfo?.quicktaleData;
        //calculate combine audio_length of all quicktales

        let userTemp = await getSingleUser(item.data()?.user);
        return {
          ...item.data(),
          id: item.id,
          userData: userTemp?.data() ? userTemp?.data() : null,
          quicktaleData: quicktaleData,
          audioLength: quicktalesInfo?.audioLength,
        };
      });

      const temp = await Promise.all(albumsPromises);
      setLoading(false);
      setAllGAAlbums(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  const handleGetAllAlbums = async () => {
    try {
      setLoading(true);
      // console.log("handleGetAllAlbums", organizationUserId);
      // const querySnapshot = await getAllAlbums(
      //   localStorage.getItem("organizationId")
      //     ? localStorage.getItem("organizationId")
      //     : currentUser.organization
      // );
      const querySnapshot = await getAllAlbums(
        organizationId ? organizationId : currentUser.organization
      );
      const albumsPromises = querySnapshot.docs.map(async (item) => {
        const quicktale = item.data().quicktales;
        const quicktalesInfo = await handleQuicktalesData(quicktale);

        const quicktaleData = quicktalesInfo?.quicktaleData;
        //calculate combine audio_length of all quicktales

        let userTemp = await getSingleUser(item.data()?.user);
        return {
          ...item.data(),
          id: item.id,
          userData: userTemp?.data() ? userTemp?.data() : null,
          quicktaleData: quicktaleData,
          audioLength: quicktalesInfo?.audioLength,
        };
      });

      const temp = await Promise.all(albumsPromises);
      setLoading(false);
      setAllAlbums(temp);
      return temp
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  const handleGetAreaAlbumsData = async (albumsIds) => {
    try {
      albumsIds = albumsIds.filter((album) => typeof album === "string");

      const albumsDataPromises = albumsIds.length
        ? albumsIds.map(async (albumId) => {
            let albumsTemp = await getAlbumbyId(albumId);
            let createdByUser = await getSingleUser(
              albumsTemp?.data()?.user
              // albumsTemp?.data()?.createdBy
            );
            return {
              ...albumsTemp?.data(),
              userData: createdByUser?.data() ?? null,
              // createdByData: createdByUser?.data() ?? null,
              id: albumId,
            };
          })
        : [];

      const albumsData = await Promise.all(albumsDataPromises);
      //calculate combine audio_length of all quicktales
      return albumsData;
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  const handleQuicktalesData = async (quicktaleIds) => {
    try {
      quicktaleIds = quicktaleIds.filter((qt) => typeof qt === "string");

      const quicktaleDataPromises = quicktaleIds.length
        ? quicktaleIds.map(async (qtId, index) => {
            let quicktaleTemp = await getSingleQuickTale(qtId);
            // createdBy can be a users.id OR an organizations.id. Use the shared
            // resolver so org-created QuickTales display the org name instead of
            // the raw id.
            const createdByData = await resolveCreatedByData(
              quicktaleTemp?.data()?.createdBy
            );
            const narratorUser = await getSingleUser(
              quicktaleTemp?.data()?.narrator
            );
            return {
              ...quicktaleTemp?.data(),
              createdByData: createdByData,
              narratorData: narratorUser?.data(),
              id: qtId,
              originalIndex: index, // Preserve original order
            };
          })
        : [];

      const quicktaleDataUnsorted = await Promise.all(quicktaleDataPromises);
      
      // Sort by original index to preserve the order from quicktaleIds
      const quicktaleData = quicktaleDataUnsorted.sort((a, b) => a.originalIndex - b.originalIndex);
      
      // Remove the temporary originalIndex property
      quicktaleData.forEach(qt => delete qt.originalIndex);

      //calculate combine audio_length of all quicktales
      let audioLength = 0;
      quicktaleData.forEach((qt) => {
        audioLength += qt.audioLength;
      });
      return {
        quicktaleData: quicktaleData,
        audioLength: formatLength(audioLength),
      };
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  return (
    <AlbumsContext.Provider
      value={{
        allGAAlbums,
        setAllGAAlbums,
        handleGetAllGAAlbums,
        handleGetAllAlbums,
        allAlbums,
        setAllAlbums,
        loading,
        setLoading,
        handleQuicktalesData,
        handleGetAreaAlbumsData,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </AlbumsContext.Provider>
  );
};
